export default __webpack_public_path__ + "static/media/ItalianTuna.19f0716d.jpg";